{
  "name": "artalk",
  "version": "2.10.0",
  "description": "A self-hosted comment system",
  "keywords": [
    "comment-system",
    "comments-widget",
    "comment",
    "comments",
    "blog"
  ],
  "homepage": "https://artalk.js.org",
  "bugs": "https://github.com/ArtalkJS/Artalk/issue",
  "repository": {
    "type": "git",
    "url": "https://github.com/ArtalkJS/Artalk.git",
    "directory": "ui/artalk"
  },
  "license": "MIT",
  "type": "module",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/main.d.ts",
        "default": "./dist/Artalk.mjs"
      },
      "require": {
        "types": "./dist/main.d.cts",
        "default": "./dist/Artalk.cjs"
      }
    },
    "./ArtalkLite": {
      "import": {
        "types": "./dist/main.d.ts",
        "default": "./dist/ArtalkLite.mjs"
      },
      "require": {
        "types": "./dist/main.d.cts",
        "default": "./dist/ArtalkLite.cjs"
      }
    },
    "./i18n/ja": {
      "import": {
        "types": "./dist/i18n/ja.d.ts",
        "default": "./dist/i18n/ja.mjs"
      },
      "require": {
        "types": "./dist/i18n/ja.d.cts",
        "default": "./dist/i18n/ja.cjs"
      }
    },
    "./i18n/zh-TW": {
      "import": {
        "types": "./dist/i18n/zh-TW.d.ts",
        "default": "./dist/i18n/zh-TW.mjs"
      },
      "require": {
        "types": "./dist/i18n/zh-TW.d.cts",
        "default": "./dist/i18n/zh-TW.cjs"
      }
    },
    "./i18n/fr": {
      "import": {
        "types": "./dist/i18n/fr.d.ts",
        "default": "./dist/i18n/fr.mjs"
      },
      "require": {
        "types": "./dist/i18n/fr.d.cts",
        "default": "./dist/i18n/fr.cjs"
      }
    },
    "./i18n/ko": {
      "import": {
        "types": "./dist/i18n/ko.d.ts",
        "default": "./dist/i18n/ko.mjs"
      },
      "require": {
        "types": "./dist/i18n/ko.d.cts",
        "default": "./dist/i18n/ko.cjs"
      }
    },
    "./i18n/ru": {
      "import": {
        "types": "./dist/i18n/ru.d.ts",
        "default": "./dist/i18n/ru.mjs"
      },
      "require": {
        "types": "./dist/i18n/ru.d.cts",
        "default": "./dist/i18n/ru.cjs"
      }
    },
    "./i18n/*": "./dist/i18n/*",
    "./Artalk.css": "./dist/Artalk.css",
    "./ArtalkLite.css": "./dist/ArtalkLite.css",
    "./dist/ArtalkLite": {
      "import": {
        "types": "./dist/main.d.ts",
        "default": "./dist/ArtalkLite.mjs"
      },
      "require": {
        "types": "./dist/main.d.cts",
        "default": "./dist/ArtalkLite.cjs"
      }
    },
    "./dist/i18n/ja": {
      "import": {
        "types": "./dist/i18n/ja.d.ts",
        "default": "./dist/i18n/ja.mjs"
      },
      "require": {
        "types": "./dist/i18n/ja.d.cts",
        "default": "./dist/i18n/ja.cjs"
      }
    },
    "./dist/i18n/zh-TW": {
      "import": {
        "types": "./dist/i18n/zh-TW.d.ts",
        "default": "./dist/i18n/zh-TW.mjs"
      },
      "require": {
        "types": "./dist/i18n/zh-TW.d.cts",
        "default": "./dist/i18n/zh-TW.cjs"
      }
    },
    "./dist/i18n/*": "./dist/i18n/*",
    "./dist/*": "./dist/*"
  },
  "main": "./dist/Artalk.js",
  "module": "./dist/Artalk.mjs",
  "types": "./dist/main.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "dev": "vite",
    "build": "pnpm build:main && pnpm build:lite && pnpm build:i18n",
    "build:main": "tsc --noEmit && vite build",
    "build:lite": "cross-env ARTALK_LITE=1 vite build",
    "build:i18n": "tsx scripts/build-i18n.ts",
    "preview": "vite preview",
    "test": "cross-env NODE_OPTIONS=--no-experimental-webstorage vitest",
    "coverage": "cross-env NODE_OPTIONS=--no-experimental-webstorage vitest run --coverage",
    "test:e2e": "playwright test",
    "test:e2e-report": "playwright show-report",
    "test:attw": "pnpx @arethetypeswrong/cli@0.18.5 --pack . --ignore-rules no-resolution",
    "lint": "eslint ."
  },
  "devDependencies": {
    "dompurify": "^3.4.12",
    "hanabi": "^0.4.0"
  },
  "dependencies": {
    "marked": "^18.0.7"
  },
  "peerDependencies": {
    "marked": "^18.0.7"
  }
}
